<!--分项能耗统计-->
<template>
	<div class="subOptionElectBody">
		<div class="top">
			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="能耗类型">
					<el-select v-model="form.type" placeholder="请选择活动区域">
						<el-option label="水" value="水"></el-option>
						<el-option label="电" value="电"></el-option>
						<el-option label="气" value="气"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div>
		<div class="center">
			<div class="center_div">
				<img :src="getImage('1yt.png')" />
				<div>
					<p>今年总{{form.type}}量</p>
					<p style="color:#ee9700;">{{yearCount}}{{unit}}</p>
				</div>
			</div>
			<div class="center_div">
				<img :src="getImage('2yt.png')" />
				<div>
					<p>折标煤</p>
					<p style="color: #ea5066;">{{getDiscount}}kgce</p>
				</div>
			</div>
			<div class="center_div">
				<img :src="getImage('3yt.png')" />
				<div>
					<p>CO2排放量</p>
					<p style="color: #4cd382;">{{getEmissions}}kg</p>
				</div>
			</div>
			<div class="center_div">
				<img :src="getImage('4yt.png')" />
				<div>
					<p>单位面积耗{{form.type}}量</p>
					<p style="color: #d34cd1;">{{nowUnit.unitArea}}/{{getunitAreaAmount}}{{unit}}</p>
				</div>
			</div>
			<div class="center_div">
				<img :src="getImage('5yt.png')" />
				<div>
					<p>人均耗{{form.type}}量</p>
					<p style="color: #2edfff;">{{nowUnit.unitPeopleNumber}}/{{getPeopleAmount}}{{unit}}</p>
				</div>
			</div>
		</div>
		<div class="bottom">
			<div class="bottom_div">
				<div class="bottom_div_title">
					<h1>昨日分项用能排行</h1>
				</div>
				<!--昨日分析用能排行-->
				<vchart ref="vchart1"></vchart>
			</div>
			<div class="bottom_div">
				<div class="bottom_div_title">
					<h1>用电同比分析</h1>
				</div>
				<!--用电同比分析-->
				<vchart ref="vchart2"></vchart>
			</div>
			<div class="bottom_div">
				<div class="bottom_div_title">
					<h1>过去31日分析用能占比</h1>
				</div>
				<!--过去31日分析用能占比-->
				<vchart ref="vchart3"></vchart>
			</div>
			<div class="bottom_div">
				<div class="bottom_div_title">
					<h1>过去31日分析用能趋势</h1>
				</div>
				<!--过去31日分析用能趋势-->
				<vchart ref="vchart4"></vchart>
			</div>
		</div>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			vchart,
		},
		props: {},
		data() {
			return {
				form: {
					type: "电",
				},
				unit: "KWh",
				option1: {
					title: {},
					series: [{
						name: '昨日分析用电排行',
						type: 'funnel',
						left: '10%',
						top: 60,
						bottom: 60,
						width: '50%',
						minSize: '0%',
						maxSize: '100%',
						sort: 'descending',
						gap: 2,
						label: {
							show: true,
							position: 'inside'
						},
						labelLine: {
							length: 10,
							lineStyle: {
								width: 1,
								type: 'solid'
							}
						},
						itemStyle: {
							borderColor: '#fff',
							borderWidth: 1
						},
						emphasis: {
							label: {
								fontSize: 20
							}
						},
						data: []
					}]
				},
				optionColotList: {
					"动力用电": '#4ECB73',
					"照明用电": "#FBD437",
					"特殊用电": "#435188",
					"其他用电": "#975FE5"
				},
				option2: {
					legend: {
						icon: "circle",
						bottom: '0',
						textStyle: {
							color: '#ffffff',
						},
						data: ["本期", "同期"]
					},
					xAxis: {
						type: 'category',
						splitLine: {
							show: false
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#ffffff'
							}
						},
						axisTick: {
							show: false
						},
						axisLine: {
							show: true,
							lineStyle:{
								color:'#0774af'
							}
						},
						data: []
					},
					yAxis: {
						type: 'value',
						splitLine: {
							lineStyle: {
								color: "#0774af",
								type: 'dashed'
							}
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#ffffff'
							}
						},
						axisTick: { //y轴刻度线
							show: true
						},
						axisLine: { //y轴
							show: false
						},
					},
					series: []
				},
				option3: {
					legend: {
						icon: "circle",
						bottom: '0',
						left: "center",
						textStyle: {
							color: '#ffffff',
						},
						data: []
					},
					tooltip: {
						trigger: 'item',
						formatter: '{b}:{d}%',
						show: true,
					},
					series: [{
						name: '',
						type: 'pie',
						radius: '55%',
						center: ['50%', '50%'],
						data: [],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				},
				option4: {
					legend: {
						icon: "circle",
						bottom: '0',
						textStyle: {
							color: '#ffffff',
						},
						data: []
					},
					tooltip: {
						trigger: 'item',
						formatter: '{a}:{c}:',
						show: true,
					},
					xAxis: {
						type: 'category',
						splitLine: {
							show: false
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#ffffff'
							}
						},
						axisLine: {
							show: true,
							lineStyle:{
								color:'#0774af'
							}
						},
						data: []
					},
					yAxis: {
						type: 'value',
						splitLine: {
							lineStyle: {
								color: "#0774af",
								type: 'dashed'
							}
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#ffffff'
							}
						},
						axisTick: { //y轴刻度线
							show: true
						},
						axisLine: { //y轴
							show: false
						},
					},
					series: []
				},
				yearCount: "", //年用量
			}
		},
		created() {},
		mounted() {
			this.$refs.vchart1.setData(this.option1)
			//用电同比分析
			let day = new Date().getDate()
			this.option2.xAxis.data = []
			for(let i = 0; i < day; i++) {
				this.option2.xAxis.data.push(i + 1)
			}
			this.$refs.vchart2.setData(this.option2)
			this.$refs.vchart3.setData(this.option3)
			this.$refs.vchart4.setData(this.option4)
			this.initData()

		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			getImage() {
				return img => {
					return resourcesStore.getters.getResourcesByName('energyEfficiencySystem/statistics/' + img)
				}
			},
			getDiscount() {
				let value = 0
				let coefficient = 0
				switch(this.form.type) {
					case '电':
						coefficient = 0.1229
						break;
					case '水':
						coefficient = 0.0857
						break;
					case '气':
						coefficient = 1.2143
						break;
				}
				if(!isempty(this.yearCount)) {
					value = (this.yearCount * coefficient).toFixed(2)
				}
				return value
			},
			getEmissions() {
				return(this.getDiscount * 2.493).toFixed(2)
			},
			getunitAreaAmount() {
				return(this.yearCount / this.nowUnit.unitArea).toFixed(2)
			},
			getPeopleAmount() {
				return(this.yearCount / this.nowUnit.unitPeopleNumber).toFixed(2)
			}
		},
		watch: {
			nowUnit(nv, ov) {
				this.initData()
			},
			'form.type': {
				deep: true,
				handler(nv, ov) {
					this.initData()
					switch(nv) {
						case "电":
							this.unit = "KWh"
							break;
						case "水":
							this.unit = "m³"
							break;
						case "气":
							this.unit = "Nm³"
							break;
					}
				}
			}
		},
		methods: {
			initData() {
				if(isempty(this.nowUnit.id)) {
					return
				}
				let appType = 0
				switch(this.form.type) {
					case "电":
						appType = 36
						break;
					case "水":
						appType = 237
						break;
					case "气":
						appType = 361
						break;
				}
				this.$api.areausePower.getSubOption(this.nowUnit.id, appType, respon => {
					if(!isempty(respon)) {
						this.yearCount = respon.yearData
						this.option1.series[0].data = []
						for(let key in respon.yesterDayRanking) {
							let obj = {
								value: respon.yesterDayRanking[key],
								name: key,
							}
							this.option1.series[0].data.push(obj)
						}
						this.$refs.vchart1.setData(this.option1)
						//用电同比分析
						this.option2.series = [{
								name: "本期",
								type: "bar",
								itemStyle: {
									color: "#38A0FF",
								},
								data: respon.yoyObject.thisMonth
							},
							{
								name: "同期",
								type: "bar",
								itemStyle: {
									color: "#4CCA73",
								},
								data: respon.yoyObject.lasMonth
							}
						]
						this.$refs.vchart2.setData(this.option2)
						//过去31日分项用能占比
						this.option3.legend.data = []
						this.option3.series[0].data = []
						for(let key in respon.percentage) {
							this.option3.legend.data.push(key)
							this.option3.series[0].data.push({
								name: key,
								value: respon.percentage[key],
							})
						}
						this.$refs.vchart3.setData(this.option3)
						//过去31日分项用能趋势
						this.option4.legend.data = []
						this.option4.xAxis.data = respon.trendXdata
						this.option4.series = []
						for(let key in respon.trend) {
							this.option4.legend.data.push(key)
							this.option4.series.push({
								name: key,
								type: "bar",
								stack: '用' + this.form.type,
								data: respon.trend[key]
							})
						}
						this.$refs.vchart4.setData(this.option4)
					} else {
						this.yearCount = 0
						this.option1.series[0].data = []
						this.$refs.vchart1.setData(this.option1)
						this.option2.series = []
						this.$refs.vchart2.setData(this.option2)
						this.option3.legend.data = []
						this.option3.series[0].data = []
						this.$refs.vchart3.setData(this.option3)
						this.option4.xAxis.data = []
						this.option4.series = []
						this.$refs.vchart4.setData(this.option4)
					}
				})
			}
		}
	}
</script>

<style scoped>
	.subOptionElectBody {
		width: 100%;
		height: 100%;
		background-color: #11173c;
	}
	
	.subOptionElectBody .top {
		width: 100%;
		height: 8%;
		display: flex;
		align-items: center;
	}
	
	.subOptionElectBody .center {
		width: 100%;
		height: 17%;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
	
	.subOptionElectBody .center_div {
		width: 17%;
		height: 60%;
		background-color: #082d76;
		border-radius: .05rem;
		border: .01rem solid #045ae8;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
	
	.subOptionElectBody .center_div img {
		width: .6rem;
		height: .6rem;
		padding-left: .1rem;
	}
	
	.subOptionElectBody .center_div div {
		width: 55%;
		height: 55%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	
	.subOptionElectBody .center_div p {
		color: white;
		font-size: .18rem;
	}
	
	.subOptionElectBody .center_div div p:nth-child(2) {
		font-size: .2rem;
	}
	
	.subOptionElectBody .bottom {
		width: 100%;
		height: 75%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	
	.subOptionElectBody .bottom .bottom_div {
		height:47%;
		background-color:#001949;
		border: .01rem solid #0263ff;
		border-radius: .05rem;
	}
	.subOptionElectBody .bottom .bottom_div:nth-child(odd){
		width: 46%;
		margin-left: 1.5%;
	}
	.subOptionElectBody .bottom .bottom_div:nth-child(even){
		width: 50%;
		margin-right: 1.5%;
	}
	.subOptionElectBody .bottom .bottom_div  .bottom_div_title{
		width: 100%;
		height: 12%;
		background-color: #082d76;
		border-bottom: .01rem solid #0263ff;
		display: flex;
		align-items: center;
		border-radius: .05rem .05rem 0 0;
	}
	.subOptionElectBody .bottom .bottom_div  .bottom_div_title h1{
		color: white;
		font-size: .2rem;
		padding-left: 1%;
	} 
	.subOptionElectBody .default-chart {
		height: 88%;
	}
</style>
<style>
	.subOptionElectBody .el-form-item {
		margin-bottom: 0;
		margin-left: .2rem;
	}
	
	.subOptionElectBody .el-form {
		display: flex;
	}
	
	.subOptionElectBody label {
		color: white;
	}
	.subOptionElectBody .el-input__inner{
		background-color: #11173c;
		border: 1px solid #0775a5;
		color: white;
	}
	
</style>